import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormikHelpers } from 'formik';
import { Header, Button, Dimmer, Message } from 'semantic-ui-react';
import { SimpleFormWrapper } from '../SimpleFormWrapper/SimpleFormWrapper';
import { Logo } from '../Logo/Logo';
import { Spinner } from '../Spinner/Spinner';
import {
	ChangePasswordFormFields,
	ChangePasswordFormProps,
	ChangePasswordForm,
} from '../ChangePasswordForm/ChangePasswordForm';
import { changePassword } from '../../services/auth';
import { AppState } from '../../types/app-state';
import { AuthState } from '../../types/auth-state';
import { USER_CHANGED_PASSWORD } from '../../actions/auth.constants';
import './ChangePasswordPage.less';

export const ChangePasswordPage: React.FC = () => {
	const { email, token } = useSelector<AppState, Partial<AuthState>>(
		(state) => state.auth
	);
	const dispatch = useDispatch();
	const [state, setState] = useState({
		verified: false,
		loading: false,
		message: '',
	});

	const handleSubmit = async (
		values: ChangePasswordFormFields,
		actions: FormikHelpers<ChangePasswordFormProps>
	) => {
		setState((state) => ({
			...state,
			loading: true,
		}));

		try {
			await changePassword(email!, token!, values.password);
			dispatch({ type: USER_CHANGED_PASSWORD });
			setState((state) => ({
				...state,
				loading: false,
				verified: true,
			}));
		} catch (e) {
			setState((state) => ({
				...state,
				loading: false,
				message: 'A server error occurred, please try again later.',
			}));
		}
	};

	return (
		<div className='changepassword-page'>
			<Dimmer inverted active={state.loading}>
				<Spinner />
			</Dimmer>
			{!state.verified && (
				<SimpleFormWrapper>
					<Logo />
					{state.message && (
						<Message negative fluid>
							<p>{state.message}</p>
						</Message>
					)}
					<ChangePasswordForm
						noCode
						onSubmit={handleSubmit}
						renderActionButtons={() => (
							<Button fluid primary type='submit'>
								Submit
							</Button>
						)}
					>
						<Header as='h3'>Change your password</Header>
					</ChangePasswordForm>
				</SimpleFormWrapper>
			)}
			{state.verified && (
				<SimpleFormWrapper>
					<Logo />
					<p>Password has been changed</p>
					<Button as={Link} to={'/'} fluid color='grey'>
						Click here to continue
					</Button>
				</SimpleFormWrapper>
			)}
		</div>
	);
};

export default ChangePasswordPage;
